import AntIcon from "@/components/icons/AntIcon";
import { formatLocaleDate } from "@/utils/formatUtils";
import { Button, DescriptionsProps, Space } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ComponentWithPermission from "../../../auth/components/ComponentWithPermission";
import { Contract } from "../../types";
import { contractPermissionsByContractType } from "../../utils";
import { ContractCancellationEffectiveEndDateModalForm } from "../ContractCancellationEffectiveEndDateModalForm";

interface CancellationDateDescriptionLabelProps {
  contract: Contract;
}

const CancellationDateDescriptionLabel = ({ contract }: CancellationDateDescriptionLabelProps) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Space size="small">
        <span>{t("contract.attrs.cancellationDate")}</span>
        <ComponentWithPermission permissions={[contractPermissionsByContractType[contract.type].limitedUpdate]}>
          <Button
            icon={<AntIcon type="edit" />}
            size="small"
            variant="text"
            color="primary"
            onClick={() => setIsModalOpen(true)}
          />
        </ComponentWithPermission>
      </Space>

      <ContractCancellationEffectiveEndDateModalForm
        contract={contract}
        isOpen={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
      />
    </>
  );
};

export const createCancellationDateDescriptionItem = (
  contract: Contract,
): NonNullable<DescriptionsProps["items"]>[number] => ({
  label: <CancellationDateDescriptionLabel contract={contract} />,
  children: contract.cancellationDate ? formatLocaleDate(contract.cancellationDate) : undefined,
});
